import { FONT_SIZE, LETTER_SPACING, ROLE_BADGE } from "../../../theme/tokens";

/**
 * The leading column every row under a group header starts with — the missing row's dashed slot and the
 * staff row's role badge alike (the artifact's `.missslot`, 28px).
 *
 * Shared so the two rows cannot drift apart: with the badge only as wide as its label, names started
 * 6px left of "Missing nurse" (and further still for a longer role), and the group read as two lists
 * stacked rather than one.
 */
export const ROW_LEAD_WIDTH_PX = 28;

/**
 * The chip geometry of a badge in a list row — `GapsRoleBadge`'s row scale, which a job chip standing in a line of
 * people (`GapsJobBadge`'s `dense`) reads too, so a role chip and a job chip in one list line up exactly.
 */
export const ROW_BADGE_GEOMETRY_SX = {
	height: ROLE_BADGE.ROW.HEIGHT,
	px: 0.5,
	borderRadius: ROLE_BADGE.ROW.RADIUS,
	fontSize: FONT_SIZE.LABEL_MICRO,
} as const;

/**
 * The treatment of an exception mark on a row of people — Charge, Trainee, OT on a staff row; Part, Agency, Double on an
 * applicant line — so every mark on the gaps screens reads as one family: uppercase, tracked, never wider than it must be.
 */
export const ROW_MARKER_SX = { flex: "none", textTransform: "uppercase", letterSpacing: LETTER_SPACING.LABEL } as const;

/**
 * How many people a list of them shows before "Show N more" — the add sheet's candidates (P3-7) and a request's
 * applicants on Open Shifts (P3-12) alike: enough to decide on the best few without pushing the rest off a phone screen.
 */
export const GAPS_SHORTLIST_SIZE = 3;
